<!--
单个商品

使用说明：

<ProductItem
 :type="'商品类型，可选small,normal'"
 :product="{Product}"
 />

Product={name: '商品名称', img: '商品图片', price: '积分价格', gainCount: 兑换数量}
-->

<template>
    <div class="wrap" :class="[type]">

        <div class="product-item" @click="goto(product.productId)">
            <Icon class="icon" :img="product.img | asProductImage" size="contain" />
            <div class="gain" v-if="type == 'normal'">已兑换 {{product.gainCount > 999 ? '999+' : product.gainCount}} 个</div>
            <div class="text">{{product.title}}</div>
            <div class="price">{{product.price}} {{priceUnit}}</div>
        </div>

    </div>
</template>

<script>
import store from '../../api/store'
export default {
  props: ["type", "product"],
  data(){
    return {
      priceUnit: store.loginedUser.config.pointName
    };
  },
  methods: {
    goto() {
      var link = "/pages/products/Detail?skuId=" + this.product.productId;
      this.$routerPush(this, link);
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  display: inline-block;
  font-size: 0;

  &.small {
    width: 100vw / 3 - 0.5vw;
    height: 54.13vw;

    .product-item {
      position: relative;
      display: inline-block;
      margin: 0.9vw 1.5vw;
      border: 0.26vw solid #ebebed;
      background: #fff;

      .icon {
        width: 29.6vw;
        height: 29.6vw;
      }

      .text {
        width: 26.1vw;
        margin: 3.46vw auto 0;
        line-height: 1.5em;
        height: 3em;
        font-size: 2.93vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-align: left;
      }

      .price {
        font-size: 2.93vw;
        color: @themeColor;
        width: 26.1vw;
        margin: 3vw auto;
        text-align: left;
      }
      .exchange {
        position: absolute;
        font-size: 2.93vw;
        margin: 3vw auto;
        top: 24vw;
        left: 2vw;
        background: #cfaea5;
        color: #fff;
        padding: 0 0.5vw;
      }
    }
  }
  &.normal {
    width: 100vw / 2  - 1vw;
    height: 72.8vw;

    .product-item {
      position: relative;
      display: inline-block;
      margin: 0.9vw 1.6vw;
      border: 0.26vw solid #ebebed;
      position: relative;
      z-index: 1;
      background: #fff;

      .icon {
        width: 45.4vw;
        height: 45.4vw;
        margin: 0 auto;
      }

      .gain {
        background: #cfaea5;
        color: #fff;
        font-size: 2.93vw;
        line-height: 4.26vw;
        padding: 0 0.8vw;
        position: absolute;
        z-index: 2;
        left: (45.4vw - 41.5vw) / 2;
        top: 45.4vw - 4.2vw;
      }

      .text {
        width: 41.3vw;
        margin: 3.46vw auto 0;
        font-size: 2.93vw;
        line-height: 1.5em;
        height: 3em;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-align: left;
      }

      .price {
        font-size: 2.93vw;
        color: @themeColor;
        width: 41.3vw;
        margin: 3vw auto;
        text-align: left;
      }

      .exchange {
        position: absolute;
        font-size: 2.93vw;
        margin: 3vw auto;
        top: 37.6vw;
        left: 2vw;
        background: #cfaea5;
        color: #fff;
        padding: 0 0.5vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ProductItem.vue